// @flow
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Redirect, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { initCornerstone } from '../../util/initCornerstone';
import ViewerRoot from './Viewer/ViewerRoot';
import { StudyLobby } from '../../studyLobby/StudyLobby';
import { Login, PrivateRoute, PublicRoute } from '../../auth/index';
import { getVolumeManager } from './Viewer/getVolumeManager';
import { tokenVerificationAragon } from '../../auth/service/tokenVerificationAragon';
import { successLogin } from '../../actions/AuthActions';
import { setStudySearchConfig } from '../../actions/ManagerActions';
import store from '../../store/store';
import { MessageWrapper } from './Common/MessageWrapper';
import { defaultStudySearchConfig } from '../../studyLobby/defaultStudySearchConfig';
import { getOpenUserData } from '../../util/userUtils';
import LicenseExpiringModal from './Header/LicenseExpiringModal';
import DatasourceQuerySwitcher from './Common/DatasourceQuerySwitcher';
import { verifyLoginToken } from '../../auth/service/verifyLoginToken';
import { getLicenseExpirationNotice } from '../../util/licenseExpirationNotice';
import ChildViewportLifecycle from './Common/ChildViewportLifecycle';

function AppLoop() {
  const volumeManager3d = getVolumeManager();
  if (volumeManager3d === undefined) return;

  for (let itView = 0; itView < volumeManager3d.all_views.length; itView++) {
    if (volumeManager3d.checkViewType(itView) && volumeManager3d.all_views[itView].hasToDraw()) {
      volumeManager3d.all_views[itView].draw();
    }
  }
  const id = requestAnimationFrame(AppLoop);
  // cancelAnimationFrame(id);
}

export const App = () => {
  const appConfig = useSelector((state) => state.config);
  const { WITH_LOGIN, WITH_LOBBY, WITH_ARAGON_LOGIN, BOOKLET_URL, ADMIN_URL, LICENSE_TOKEN, AUTH_TOKEN_FROM_URL_PARAM, AUTH_TOKEN_FROM_URL_PARAM_NAME, CLOUD_WITH_AUTH, OPEN_ID_CONNECT } = appConfig;
  const { isLoggedIn, isLoggingIn, studyPathname } = useSelector((state) => state.authentication);
  const alert = useSelector((state) => state.alert);
  const pathname = studyPathname;
  const defaultProps = { WITH_LOGIN, WITH_ARAGON_LOGIN, WITH_LOBBY, LICENSE_TOKEN, AUTH_TOKEN_FROM_URL_PARAM, AUTH_TOKEN_FROM_URL_PARAM_NAME, isLoggedIn, isLoggingIn, message: alert.message, pathname };
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const message = getLicenseExpirationNotice(appConfig.licenseExpirationDate, t);
    if (!message) return;

    setShowModal(true);
    setModalMessage(message);
  }, []);

  initCornerstone(appConfig);

  // Cookie Login
  useEffect(() => {
    const studySearchConfig = defaultStudySearchConfig;

    if (WITH_LOGIN) {
      verifyLoginToken(appConfig, studySearchConfig);
    }
    if (!WITH_LOGIN && !CLOUD_WITH_AUTH && !OPEN_ID_CONNECT) {
      const username = getOpenUserData();
      if (username) store.dispatch(successLogin(username));
    }

    store.dispatch(setStudySearchConfig(studySearchConfig));
  }, [isLoggedIn]);

  // aragon login
  useEffect(() => {
    if (WITH_ARAGON_LOGIN) {
      tokenVerificationAragon();
    }
  }, [WITH_ARAGON_LOGIN]);

  const AdminLink = () => { window.location.href = ADMIN_URL; };
  const BookletLink = () => { window.location.href = BOOKLET_URL; };

  const subdirectory = typeof siteSubdirectory === 'string' ? siteSubdirectory : '';

  return isLoggingIn ? (
    <MessageWrapper>Verificando acceso...</MessageWrapper>
  ) : (
    <>
      <LicenseExpiringModal show={showModal} message={modalMessage} onClose={closeModal} />
      <Router basename={subdirectory}>
        <DatasourceQuerySwitcher />
        <ChildViewportLifecycle />
        <Switch>
          <PrivateRoute {...defaultProps} exact path="/viewer/patient/:PatientId" component={ViewerRoot} />
          <PrivateRoute {...defaultProps} exact path="/viewer/access/:AccessionNumber/series/:SeriesInstanceUIDs" component={ViewerRoot} />
          <PrivateRoute {...defaultProps} exact path="/viewer/study/:StudyInstanceUID/series/:SeriesInstanceUIDs" component={ViewerRoot} />
          <PrivateRoute {...defaultProps} exact path="/viewer/access/:AccessionNumber" component={ViewerRoot} />
          <PrivateRoute {...defaultProps} exact path="/viewer/study/:StudyInstanceUID" component={ViewerRoot} />
          <PrivateRoute {...defaultProps} exact path="/studies" component={StudyLobby} showComponent={WITH_LOBBY} />
          {/* <PublicRoute {...defaultProps} path="/forgot_password" component={ForgotPassword} showComponent={WITH_RECOVERY_PASS} /> */}
          {/* <PublicRoute {...defaultProps} path="/reset_password" component={ResetPassword} /> */}
          <PublicRoute {...defaultProps} path="/admin" component={AdminLink} />
          <PublicRoute {...defaultProps} path="/booklet" component={BookletLink} />
          <PublicRoute {...defaultProps} exact path="/" component={Login} />
          <PublicRoute {...defaultProps} exact path="/login" component={Login} />
          {/* <PublicRoute {...defaultProps} path="/register" component={Register} /> */}
          <Redirect to="/" />
        </Switch>
      </Router>
    </>
  );
};

AppLoop();

export default App;
